import { Divider, Grid, Stack, Typography } from "@mui/material";
import { StandardCellList } from "../../../../components/Standards";
import React from "react";
import { useDispatchWrapper } from "../../../../hooks";
import { IStoreState } from "../../../../redux/initialStoreState";
import { useSelector } from "react-redux";
import { formatDate, formatTime } from "../../../../helpers";
import { PageLoader } from "../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../constants/enums";
import { ITaskFileUploadAttachment } from "../../../../redux/tasks/task.types";
import { FileUpload } from "../../../../components/FileUpload/FileUpload";
import { StandadCard } from "../../../../components/Cards";
import { ITaskLooBor } from "../../../../redux/taskUrgentTransactions/taskUrgentTransactions.types";
import { fetchTaskLAOAysnc } from "../../../../redux/taskUrgentTransactions/taskUrgentTransactionsActions";

export const ViewLaoBor: React.FC<{
  taskCode: string;
  attachment: ITaskFileUploadAttachment[];
}> = (props) => {
  const { taskCode, attachment } = props;
  const { data, loading } = useSelector(
    (storeState: IStoreState) => storeState.tasks.urgentTransactions.loa
  );
  const dispatch = useDispatchWrapper();
  const [taskDetails, setTaskDetails] = React.useState<ITaskLooBor>();

  React.useEffect(() => {
    dispatch(fetchTaskLAOAysnc(taskCode));
  }, [taskCode]);

  React.useEffect(() => {
    if (data) {
      setTaskDetails(data);
    }
  }, [data]);

  return (
    <PageLoader loading={loading === LoadState.InProgress}>
      {taskDetails && (
        <Grid container spacing={1} sx={{ mt: 2 }}>

          <Grid item xs={12} lg={12}>
            <StandardCellList
              heading="Urgent Transaction"
              colSize={3}
              list={[
                {
                  heading: "LAO/BOR",
                  data: {
                    type: "text",
                    value: taskDetails.lao_or_bor,
                  },
                },
                {
                  heading: "Signed Cancellation Form",
                  data: {
                    type: "text",
                    value: taskDetails.signed_change_form,
                  },
                },
                {
                  heading: "Effective Date",
                  data: {
                    type: "text",
                    value: formatDate(taskDetails.effective_date_of_change),
                  },
                },
                {
                  heading: "Effective Time",
                  data: {
                    type: "text",
                    value: formatTime(
                      taskDetails.effective_time_of_change || ""
                    ),
                  },
                },
                {
                  heading: "Details",
                  colSize: 12,
                  data: {
                    type: "text",
                    value: taskDetails.details,
                  },
                },
              ]}
            >
                       <Divider sx={{ mt: 2, mb: 2 }} />
              <Grid container>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="body1"
                    fontSize={"1.2rem"}
                    fontWeight={600}
                  >
                    Attachments
                  </Typography>
                  {attachment.length > 0 ? (
                    attachment.map((item) => {
                      return (
                        <Stack
                          key={item.key}
                          direction={"row"}
                          justifyContent={"center"}
                          gap={2}
                          alignItems={"center"}
                        >
                          <Typography
                            variant="h4"
                            textTransform={"capitalize"}
                            width={"30%"}
                          >
                            {" "}
                            {item.fileName}{" "}
                          </Typography>
                          <FileUpload value={item.url} deleteDisabled />
                        </Stack>
                      );
                    })
                  ) : (
                    <Typography variant="body1">No attachments</Typography>
                  )}
                </Grid>
              </Grid>
            </StandardCellList>
          </Grid>
      
        </Grid>
      )}
    </PageLoader>
  );
};
